import { render, staticRenderFns } from "./EnterCode.vue?vue&type=template&id=12edf669&scoped=true&"
import script from "./EnterCode.vue?vue&type=script&lang=js&"
export * from "./EnterCode.vue?vue&type=script&lang=js&"
import style0 from "./EnterCode.vue?vue&type=style&index=0&id=12edf669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12edf669",
  null
  
)

export default component.exports